import DeliveryTimeItems from "../delivery-time-items";

class TimeItemFactory {
  static create(data, isFiltered = false) {
    return new DeliveryTimeItems(data, isFiltered);
  }
}

export default TimeItemFactory;